'use client';

import { useCallback } from 'react';
import { sendGTMEvent } from '@next/third-parties/google';
import {
  EVENT_SELECT_PROMOTION,
  EVENT_VIEW_PROMOTION
} from '../../constants/analyticsConstants';

interface EspotEventProps {
  name: string;
  creative: string;
  source: string;
  locale: string;
  espotType: string;
  position?: number;
  promoClick?: boolean;
}

export const useEspotEvent = () => {
  const buildEvent = useCallback(
    ({
      name,
      creative,
      source,
      locale,
      espotType,
      position = 1,
      promoClick = false
    }) => {
      const sanitizeName = name?.trim();
      const sanitizeCreative = creative?.trim();
      const sanitizeSource = source?.trim();
      const promotions = {
        creative_name: `${sanitizeCreative ?? ''} - ${locale} - ${sanitizeSource ?? ''}`,
        creative_slot: position,
        promotion_id: `${espotType}`,
        promotion_name: sanitizeName
      };

      return {
        event: promoClick ? EVENT_SELECT_PROMOTION : EVENT_VIEW_PROMOTION,
        cartDetails: {
          cartID: ''
        },
        ecommerce: {
          ...promotions,
          items: []
        }
      };
    },
    []
  );

  const fireEvent = useCallback(
    (data: EspotEventProps) => {
      sendGTMEvent(buildEvent(data));
    },
    [buildEvent]
  );

  return { fireEvent };
};
